import React, {useEffect, useState}						from 'react';
import {useNavigate}							from 'react-router-dom';

import {useAppDispatch, useAppSelector}			from '../app/hooks';
import {checkIsConnected}						from '../redux/user/user';

import Input									from '../ressources/components/Input';
import Button									from '../ressources/components/Button';

import {InputValues}							from '../ressources/components/Input/interface';

import {regex_password}							from '../ressources/data/regex';

import LANGUAGE									from '../ressources/language';
import * as API									from '../ressources/API';

import './Login.css';

interface Props {
	id: string,
	token: string
}

function	PasswordReset(props: Props) {
	const dispatch = useAppDispatch();
	const lang = useAppSelector(state => state.settings.lang);

	const [password, set_password] = useState<InputValues>('');
	const [passwordConfirm, set_passwordConfirm] = useState<InputValues>('');
	const [view, set_view] = useState('reset');
	const [errorResponse, set_errorResponse] = useState('');
	const [load, set_load] = useState(false);

	const TEXTE = LANGUAGE(lang);
	const navigate = useNavigate();

	useEffect(() => set_errorResponse(''), [password, passwordConfirm]);

	function onClick() {
		if (view === 'confirm')
			return navigate('/login');

		set_load(true);

		API.forgetPasswordReset(props.id, props.token, password as string)
		.then((response) => {
			set_load(false);
			if (response.error)
				return set_errorResponse(response.error);

			set_view('confirm');
			dispatch(checkIsConnected(response.data));
			navigate('/home');
		});
	}

	return (
		<div className={'loginMain'}>
			<div className={'loginContainer'}>
				<div className={'loginFormContainer'}>
					<div className={`loginLogo ${view}`} />

					<div className={'loginText'}>
						<span>{view === 'reset' ? TEXTE.login.choosePassword : TEXTE.login.accountCreate}</span>
						<span>{view === 'reset' ? TEXTE.login.notEasyPassword : TEXTE.login.passwordSave}</span>
					</div>

					{view === 'reset' &&
						<Input
							type={'password'}
							value={password}
							onChange={set_password}
							title={TEXTE.global.password}
							error={!!(password && !regex_password.test(password as string))}
						/>
					}
					{view === 'reset' &&
						<div className={'loginPasswordRules gray-600'}>
							<span>{TEXTE.login.passwordRules.text}</span>
							{TEXTE.login.passwordRules.rules.map((e, i) => <span key={`rules-${i}`}>{e}</span>)}
						</div>
					}
					{view === 'reset' &&
						<Input
							type={'password'}
							value={passwordConfirm}
							onChange={set_passwordConfirm}
							title={TEXTE.login.confirmPassword}
							error={!!((password || passwordConfirm) && password !== passwordConfirm)}
						/>
					}

					{(errorResponse) && <span className={'weight-500 error-600'}>{errorResponse}</span>}

					<Button
						fullWidth
						isLoad={load}
						onClick={onClick}
						disabled={!regex_password.test(password as string) || password !== passwordConfirm}
					>
						{view === 'reset' ? TEXTE.login.validatePassword : TEXTE.global.continue}
					</Button>
				</div>
			</div>
			<div className={`loginBackground ${view}`} />
		</div>
	);
}

export default PasswordReset;
